export enum TicketState {
  Open = 'open',
  Paused = 'paused',
  Pending = 'pending',
  Resolved = 'resolved',
}
